import { Navigate } from '@exam-management/router';

export default function LoginPage() {
  return <Navigate to='/' replace />;
}
